// Mise en forme française des nombres et des dates.

import type { DateIso, Projet } from "./domaine/types";

const pourcentage = new Intl.NumberFormat("fr-FR", { style: "percent", maximumFractionDigits: 0 });
const score = new Intl.NumberFormat("fr-FR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const moisAnnee = new Intl.DateTimeFormat("fr-FR", {
  month: "short",
  year: "numeric",
  timeZone: "UTC",
});

export const formaterPourcentage = (part: number | null): string =>
  part === null ? "—" : pourcentage.format(part);

export const formaterScore = (valeur: number): string => score.format(valeur);

export const formaterMois = (date: DateIso): string =>
  moisAnnee.format(new Date(`${date}T00:00:00Z`));

/** Une date manquante se dit, elle ne s'invente pas (règle R6 du POC). */
export function formaterPeriode(p: Pick<Projet, "dateDebut" | "dateFin" | "dureeMois">): string {
  if (!p.dateDebut && !p.dateFin) return "non renseignée";
  const debut = p.dateDebut ? formaterMois(p.dateDebut) : "début inconnu";
  const fin = p.dateFin ? formaterMois(p.dateFin) : "fin inconnue";
  return `${debut} → ${fin}${p.dureeMois ? ` · ${p.dureeMois} mois` : ""}`;
}

export const pluriel = (n: number, singulier: string, plurielForme = `${singulier}s`): string =>
  `${n} ${n > 1 ? plurielForme : singulier}`;
